var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section hotGame"},[_c('div',{staticClass:"h-tt"},[_c('h2',[_vm._v("热门页游")]),_vm._v(" "),_c('a',{staticClass:"more",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.$router.push('/all-game')
        _vm.$util.clickStat(`GWSY/RMYY/SYYX`, `官网首页/热门页游/所有游戏`)}}},[_vm._v("\n      所有游戏\n    ")])]),_vm._v(" "),_c('GameList',{attrs:{"list":_vm.games,"stat-params":_vm.statParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }